import { useCallback, useRef } from 'react';

import { hasValue } from '@core/utils/equality';

export function useDebouncedCallback<T extends (...args: any[]) => void>(
  callback: T,
  delay: number,
): (...args: Parameters<T>) => void {
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  const debounced = useCallback(
    (...args: Parameters<T>) => {
      if (hasValue(timeoutRef.current)) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        callback(...args);
      }, delay);
    },
    [callback, delay],
  );

  return debounced;
}
